var Dom = {}

Dom.getLastEle = function(_e) {
	return _e.previousSibling;
}
Dom.getEleH = function(_e) {
	return _e.offsetHeight;
}
Dom.getEleW = function(_e) {
	return _e.offsetWidth;
}
Dom.getEleHW = function(_e) {
	return {
		width: this.getEleW(_e),
		height: this.getEleW(_e)
	}
}
Dom.setEleStyle = function(_e, str) {
	_e.style += ';' + str;
}
Dom.getEleD = function(_e) {
	return {
		top: _e.offsetTop,
		left: _e.offsetLeft,
		right: _e.offsetLeft + this.getEleW(_e),
		bottom: _e.offsetTop + this.getEleH(_e),
		width: this.getEleW(_e),
		height: this.getEleH(_e)
	}
}
Dom.getFile = function(fn, _fn) {
	let _input = document.getElementById('getFiles');
	if (_input != null) {
		_input.innerHTML=''
	}
	let input = document.createElement('input');
	input.id="getFiles";
	input.type = 'file';
	input.style = 'position: absolute;z-index: -999;display: none;';
	input.onchange = fn;
	document.body.appendChild(input);
	_input = input;
	
	_input.click();
	_input.blur();
	if (_fn) _fn();
	return _input;
}
Dom.elTableFit = function(table) {
	const colgroup = table.querySelector("colgroup");
	const colDefs = [...colgroup.querySelectorAll("col")];
	var res=[];
	colDefs.forEach((col) => {
		const clsName = col.getAttribute("name");
		const cells = [
			...table.querySelectorAll(`td.${clsName}`),
			...table.querySelectorAll(`th.${clsName}`),
		];
		// 忽略加了"leave-alone"类的列
		if (cells[0]?.classList?.contains?.("leave-alone")) {
			return;
		}
		const widthList = cells.map((el) => {
			let txtwidth = 0;
			// console.log(el.querySelector(".cell")?.innerText,clsName)
			if (el.querySelector(".cell")?.innerText?.length > 0) {
				// console.log(el.querySelector(".cell"))
				for (const char of el.querySelector(".cell")?.innerText) {
					if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
						// 如果是英文字符，为字符分配8个单位宽度
						txtwidth += 9;
						if((char >= 'A' && char <= 'Z')) txtwidth += 2;
					} else if (char >= '\u4e00' && char <= '\u9fa5') {
						// 如果是中文字符，为字符分配15个单位宽度
						txtwidth += 12;
					} else if ((char >= 0 && char <= 9)) {
						txtwidth += 7;
					} else if(/[^\x00-\x80]/g.test(char)){
						txtwidth += 12;
					}else {
						// 其他种类字符，为字符分配8个单位宽度
						txtwidth += 12;
					}
				}
				// console.log(el.querySelector(".sort_icon"))
				if(el.querySelector(".sort_icon")!=null){
					txtwidth+=8;
				}
			}
			if(el.querySelector(".el-input__inner")!=null){
				txtwidth+=10;
			}
			if(el.querySelector(".el-date-editor")!=null){
				txtwidth+=135;
				// console.log('date',txtwidth)
			}
			return txtwidth;
			// return el.querySelector(".cell")?.scrollWidth || 0;
		});
		const max = Math.max(...widthList);
		const padding = 32;
		// console.log(max+32,clsName)
		let all=max+32;
		all=all<60?60:all;
		res.push(all);
		// table.querySelectorAll(`col[name=${clsName}]`).forEach((el) => {
		// 	el.setAttribute("width", max + padding);
		// });
	});
	// const header = table.querySelector(".el-table__header-wrapper");
	// let temwidth = table.offsetHeight - header.offsetHeight;
	// table.querySelector(".el-table__body-wrapper").setAttribute('style', `height:${temwidth}px;`);
	return res;
}
export const dom = Dom;
